module.exports = __webpack_public_path__ + "static/media/Roya-Resort-Notice.d989390a.png";